import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters(["getDefaultDateFormat"])
    },
    methods: {
        moment,
        dateCalculation(date) {
            const today = this.moment().format(this.getDefaultDateFormat);
            const dueDate = this.moment(date).format(
                this.getDefaultDateFormat
            );

            const todayFormated = this.moment(today, this.getDefaultDateFormat);
            const dueDateFormated = this.moment(dueDate, this.getDefaultDateFormat);
            const calc = dueDateFormated.diff(todayFormated, "days");

            return calc;
        },
    }
}